export const COLUMNSPEMASUKAN = [
  {
    Header: 'ID',
    accessor: 'Bill.id',
  },
  {
    Header: 'Order',
    accessor: 'order',
  },
  {
    Header: 'Status Pembayaran',
    accessor: 'paymentStatus',
  },
  {
    Header: 'Waktu Transaksi',
    accessor: 'timestamp',
  },
  {
    Header: 'Jenis Pembayaran',
    accessor: 'Bill.jenis_pembayaran',
  },
  {
    Header: 'Total',
    accessor: 'total',
  },
  {
    Header: 'Uang Masuk',
    accessor: 'cash_in',
  },
  {
    Header: 'Uang Keluar',
    accessor: 'cash_out',
  },
  {
    Header: 'Aksi',
    accessor: 'actions',
  },
];